import { Infinity, Shield, Banknote } from "lucide-react";

export const DASPricing = () => {
  return (
    <section id="pricing" className="py-12 md:py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-black mb-4">
            Transparente Preise
          </h2>
          <p className="text-lg md:text-xl text-gray-700">Alle Preise verstehen sich pro 24 Stunden</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4 md:space-y-6">
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-card">
            <div className="flex items-start gap-3 md:gap-4">
              <Infinity className="h-6 w-6 md:h-8 md:w-8 text-gold flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg md:text-xl mb-2">Unbegrenzte Kilometer</h3>
                <p className="text-gray-700">
                  Fahren Sie so viel Sie möchten – ohne Kilometerbegrenzung bei allen Fahrzeugen.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 md:p-6 rounded-lg shadow-card">
            <div className="flex items-start gap-3 md:gap-4">
              <Banknote className="h-6 w-6 md:h-8 md:w-8 text-gold flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg md:text-xl mb-2">CHF 300 Kaution</h3>
                <p className="text-gray-700">
                  Einheitliche Kaution von CHF 300.- für alle Fahrzeuge. 
                  Wird bei ordnungsgemässer Rückgabe vollständig zurückerstattet.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 md:p-6 rounded-lg shadow-card">
            <div className="flex items-start gap-3 md:gap-4">
              <Shield className="h-6 w-6 md:h-8 md:w-8 text-gold flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-heading font-bold text-lg md:text-xl mb-2">Versicherung inklusive</h3>
                <p className="text-gray-700">
                  Vollkasko- und Haftpflichtversicherung im Preis inbegriffen. 
                  Selbstbehalt CHF 1'000.- im Schadensfall.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gold text-white p-4 md:p-6 rounded-lg shadow-card text-center">
            <h3 className="font-heading font-bold text-xl md:text-2xl mb-2">
              Wochen- und Monatspreise
            </h3>
            <p className="text-base md:text-lg">
              Benötigen Sie ein Fahrzeug für länger? Kontaktieren Sie uns via WhatsApp 
              für attraktive Wochen- und Monatskonditionen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
